require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tutorials-examples-microwave-parallel.json") })
        }
      }, "path---tutorials-examples-microwave-parallel");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tutorials-examples-microwave-parallel!./.cache/json/tutorials-examples-microwave-parallel.json
// module id = 778
// module chunks = 231608221292675